import { render, staticRenderFns } from "./UninstalledAddon.vue?vue&type=template&id=3804a91e&scoped=true"
import script from "./UninstalledAddon.vue?vue&type=script&lang=js"
export * from "./UninstalledAddon.vue?vue&type=script&lang=js"
import style0 from "./UninstalledAddon.vue?vue&type=style&index=0&id=3804a91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804a91e",
  null
  
)

export default component.exports